/**
 * Agent Selection Column Definitions
 * 
 * TanStack Table column definitions for Agent selection in GroupManagement modal
 * Optimized for selection interface with checkboxes
 */

import { ColumnDef } from '@tanstack/react-table';
import { FiCpu } from 'react-icons/fi';
import type { AgentListItem } from '@/types';
import styles from './agentSelectionColumns.module.css';

/**
 * Agent Selection Columns for DataTable with row selection
 */
export const agentSelectionColumns: ColumnDef<AgentListItem>[] = [
  {
    id: 'select',
    header: ({ table }) => (
      <input
        type="checkbox"
        className={styles.checkbox}
        checked={table.getIsAllPageRowsSelected()}
        onChange={table.getToggleAllPageRowsSelectedHandler()}
        aria-label="Selecionar todos os agentes"
      />
    ),
    cell: ({ row }) => (
      <input
        type="checkbox"
        className={styles.checkbox}
        checked={row.getIsSelected()}
        onChange={row.getToggleSelectedHandler()}
        aria-label={`Selecionar agent ${row.original.name}`}
      />
    ),
    enableSorting: false,
    size: 50,
  },
  {
    id: 'name',
    accessorKey: 'name',
    header: 'Nome',
    cell: ({ row }) => (
      <div className={styles.agentNameCell}>
        <FiCpu size={16} className={styles.agentIcon} />
        <span className={styles.agentName}>{row.original.name}</span>
      </div>
    ),
    enableSorting: true,
    size: 200,
  },
  {
    id: 'hostname',
    accessorKey: 'hostname',
    header: 'Hostname',
    cell: ({ getValue }) => {
      const value = getValue() as string | undefined;
      return (
        <span className={styles.hostnameCell}>
          {value || '-'}
        </span>
      );
    },
    enableSorting: true,
    size: 150,
  },
  {
    id: 'os',
    accessorKey: 'os',
    header: 'Sistema',
    cell: ({ row }) => {
      const os = row.original.os;
      const osVersion = row.original.osVersion;
      
      return (
        <div className={styles.osCell}>
          {os ? (
            <span className={styles.osName}>
              {os} {osVersion || ''}
            </span>
          ) : (
            '-'
          )}
        </div>
      );
    },
    enableSorting: true,
    size: 120,
  },
];